const { createBrowserHistory, createMemoryHistory } = require('history');
const { canUseDOM } = require('./dom-utils');

const factory = (config) => (canUseDOM ? createBrowserHistory(config) : createMemoryHistory(config));

module.exports = (config) => factory(config);
